import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    depositContext: {
        flex: 1,
    },

    name: {
        color: theme.palette.info.light,
        padding: '10px 0',
        maxWidth: '200px',
        fontWeight: 500,
        fontSize: '1.25rem',
        fontFamily: ["Heebo", "sans-serif"].join(',')

    },
    fun: {
      display: 'inline-block',
      transform: 'rotateZ(-9deg)',
    },

    hide: {
        display: 'none',
    },
    show: {
        display: 'block'
    }
}));

const AppName = ({ open }) => {
    const classes = useStyles();
    return (
        <div className={clsx(classes.name, !open && classes.hide)}>
            <div className="name animated pulse">
                ShopX
            </div>
        </div>
    );
}

export default AppName;


